import React from 'react';
import PropTypes from 'prop-types';
import { MdClose } from 'react-icons/md';
import { useTranslation } from '@blaze-cms/nextjs-components';
import { TRANSLATION_NAMESPACE } from '../../../constants';

const CloseMobileForm = ({ handleClose }) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE);
  return (
    <div className="filter__header filter__header--mobile">
      <p>{t('MOBILE_REFINEMENT_TITLE')}</p>

      <i role="button" onClick={handleClose} aria-label="Close">
        <MdClose />
      </i>
    </div>
  );
};

CloseMobileForm.propTypes = {
  handleClose: PropTypes.func.isRequired
};

export default CloseMobileForm;
